import script from "./MainLoginComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./MainLoginComponent.vue?vue&type=script&setup=true&lang=js"

import "./MainLoginComponent.vue?vue&type=style&index=0&id=10687d6a&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10687d6a"]])

export default __exports__